module.exports = __webpack_public_path__ + "assets/img/ruanjian.485f1fe8.png";